var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPfBills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19309 15L6.09532 12.7077C5.99845 12.637 5.97262 12.5146 6.03074 12.4171L6.25893 12.029C6.92197 10.9068 7.25779 9.6928 7.25779 8.42144C7.25779 7.42539 7.04682 6.45227 6.63134 5.52887L6.41393 5.04709C6.35365 4.91326 6.42684 4.76414 6.57753 4.71061L14.1551 2.01877C14.3037 1.96524 14.4737 2.03025 14.534 2.16216L14.7514 2.64394C15.5802 4.4831 16 6.42551 16 8.42144H14.2498C14.2498 6.88817 13.9743 5.38739 13.4296 3.95162L8.55158 5.68372C8.85727 6.56889 9.01226 7.48657 9.01226 8.41953C9.01226 9.71192 8.70658 10.9986 8.12319 12.1782L10.3168 13.8013L9.19309 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.57197C13.6357 4.99432 13.9573 6.47917 13.9573 8H16C16 6.28409 15.6282 4.60417 14.897 3L13 3.57197Z",
    fill: "url(#paint0_linear_360_388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01424 12.5329L8.93998 15L10 13.714L7.96542 12L6 12.5206C6.0061 12.5247 6.01017 12.5288 6.01424 12.5329Z",
    fill: "url(#paint1_linear_360_388)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1834 8C11.0485 8 10.9393 8.10448 10.9393 8.23366V8.77128C10.9393 12.0084 9.44665 14.9187 7.08461 16.9039C6.97147 16.9988 6.97147 17.1679 7.08659 17.261L12.954 21.9456C13.0532 22.0254 13.1981 22.0159 13.2874 21.9267L13.6507 21.5619C17.1005 18.0988 19 13.5566 19 8.77128V8.23366C19 8.10448 18.8908 8 18.7559 8H11.1834ZM12.9917 19.9643L9.27594 17.0007C11.2172 14.9244 12.3506 12.3256 12.5272 9.54445L17.3664 9.54635C17.1858 13.4065 15.6535 17.0577 12.9917 19.9643Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_388",
    x1: 14.5019,
    y1: 11.9237,
    x2: 14.5019,
    y2: 4.70509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_388",
    x1: 8.00251,
    y1: 17.3542,
    x2: 8.00251,
    y2: 13.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPfBills);
export default __webpack_public_path__ + "static/media/logo-pf-bills.3517e26b5a5587795f4158d85bfb4376.svg";
export { ForwardRef as ReactComponent };